<style>fieldset.group  {
  margin: 0;
  padding: 0;
  margin-bottom: 1.25em;
  padding: .125em;
}

fieldset.group legend {
  margin: 0;
  padding: 0;
  font-weight: bold;
  margin-left: 20px;
  font-size: 100%;
  color: black;
}


ul.checkbox  {
  margin: 0;
  padding: 0;
  margin-left: 20px;
  list-style: none;
}

ul.checkbox li input {
  margin-right: .25em;
}

ul.checkbox li {
  border: 1px transparent solid;
  display:inline-block;
  width:16em;
}

</style>

<h3>Überweisungen</h3>

<form class="form-vertical">
  <!-- Überweisung für: -->
  <div class="form-group" ng-show="vm.standalone">
    <!-- Patientensuche -->
    <label for="reffor">Patient</label>
    <div class="form-group  col-xs-12" ng-hide="vm.newref.patientid">
      <clientsearch id="patient" parentsave="vm.savePatient(client, mode)" mode="patient"></clientsearch>
    </div>
    <div class="form-group col-xs-12" ng-show="vm.newref.patientid">
      <div class="input-group">
        <input type="text" class="form-control"
               id="patientname"
               tabindex="0"
               readonly
               ng-model="vm.newref.patient.fname">
        <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>
                    </button>
                </span>
      </div>
    </div>
  </div>

  <!-- Überweisungsart: lab, img, default -->
  <div style="font-weight:bold"><label>Überweisungsart</label></div>
  <div class="form-group">
    <div class="radio" ng-init="vm.newref.reftype = 'std'">
      <label for="stdref" class="radio-inline">
        <input type="radio" ng-value="std" tabindex="1"
               ng-model="vm.newref.reftype"
               id="stdref"> Standard</label>
      <label for="labref" class="radio-inline">
        <input type="radio" value="lab" tabindex="2"
               ng-model="vm.newref.reftype"
               ng-click="vm.setlab()"
               id="labref"> Labor</label>
      <label for="imgref" class="radio-inline">
        <input type="radio" value="img"
               ng-model="vm.newref.reftype"
               ng-click="vm.setimg()"
               id="imgref"> Bildgebende Diagnostik</label>

    </div>
  </div>
</form>

<!-- Überweisung an: -->
<form class="form-vertical" id="refform" name="refform">
  <div class="form-group">
    <label for="refto">
      <span
          uib-tooltip="Es muß entweder ein Arzt aus der Liste ausgewählt werden oder das Feld Freitext ausgefüllt werden">
        An/Zu: Arztauswahl ODER freie Texteingabe
      </span>
      <span uib-tooltip="Pflichtfeld">*</span>
    </label>
    <!-- Arztsuche -->
    <div class=" row">
      <!-- Arztsuche - -->
      <div class="form-group  col-xs-12" ng-hide="vm.newref.doctor._id">
        <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>
      </div>
      <div class="form-group col-xs-12" ng-show="vm.newref.doctor._id">
        <div class="input-group">
          <input type="text" class="form-control"
                 id="pdoctorname"
                 tabindex="0"
                 readonly
                 ng-model="vm.newref.doctor.fname">
          <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>
                    </button>
                </span>
        </div>
      </div>
    </div>
    <div class=" row">
      <!-- Freitext -->
      <div class="col-xs-12 spacer-bottom">
        <input type="text" ng-model="vm.newref.to" tabindex="0"
               ng-required="!(vm.newref.to || vm.newref.doctor)"
               ng-hide="vm.newref.doctor"
               tabindex="0"
               style="margin-top: -5px;"
               placeholder="Freitext für Überweisungsziel" class="form-control" id="refto">
      </div>

    </div>
    <!-- diagnose/Begründung -->
    <div class="form-group">
      <label for="refdiag">Diagnose/Begründung<span uib-tooltip="Pflichtfeld">*</span></label>
      <fieldset class="group">
          <ul class="checkbox">
            <li ng-repeat="diag in vm.diagnoses">
              <input type="checkbox" id="diag{$index}" ng-model="diag.use" ng-change="vm.setDiag()"/>
              <label for="diag{$index}">{{diag.text}}</label></li>
          </ul>
        </fieldset>
      </fieldset>
      <input required type="text" ng-model="vm.newref.diag"
             class="form-control" id="refdiag" tabindex="0">
    </div>

    <!-- Selected Labvalue Output -->
    <div ng-if="vm.newref.reftype === 'lab'">
      <labreferral parentsave="vm.saveLabvalues(allvalues, ginclude, additionalvalues, cleangroups)"
                   reset="vm.labreset">
      </labreferral>
    </div>

    <!-- Selected Imaging Output -->
    <div ng-if="vm.newref.reftype === 'img'">
      <imagingreferral parentsave="vm.saveImagingvalues(allvalues, ginclude, additionalvalues)"
                       reset="vm.imagingreset">
      </imagingreferral>
    </div>

    <!-- Erbeten -->
    <div class="form-group">
      <label for="refref">Erbeten<span uib-tooltip="Pflichtfeld">*</span></label>
      <textarea class="form-control" ng-model="vm.newref.ref" rows="5"
                ng-required="!(vm.newref.ref || vm.newref.labvalues || vm.newref.imagingvalues)"
                id="refref" tabindex="4"></textarea>
    </div>

    <!-- gültig -->
    <div class="form-group">
      <label>Gültig </label>
      <div class="radio">
        <label class="radio-inline">
          <input type="radio" ng-value="true" ng-model="vm.newref.pdate"
                 ng-click="vm.setRefDate()">
          1 Monat</label>
        <label class="radio-inline">
          <input type="radio" ng-value="false" ng-model="vm.newref.pdate"
                 ng-click="vm.newref.refdate = ''">
          Kein Datum</label>
      </div>
    </div>

    <!-- Buttons -->
    <div ng-show="vm.standalone" class="spacer-bottom ">
      <button class="btn btn-success" ng-disabled="refform.$invalid" type="button" ng-click="vm.print();"
              tabindex="0">
        Drucken
      </button>

<!--      <button class="btn btn-info" ng-disabled="refform.$invalid" type="button" ng-click="vm.preview();" tabindex="0">
        <i class="fa fa-file-pdf-o" ng-hide="vm.previewed"></i>
        <i class="fa fa-check-circle-o" ng-show="vm.previewed"></i>
        PDF Vorschau
      </button>-->

      <a href="{{vm.previewurl}}" class="btn btn-primary" uib-tooltip="Vorschau PDF in neuem Fenster öffnen"
         ng-show="vm.previewed" type="button" tabindex="0" target="_blank">
        <i class="fa fa-file-pdf-o"></i>
      </a>

    </div>
    <div class="alert alert-success" ng-show="vm.printed === true"><i class="fa fa-check"></i> Überweisung erfolgreich
      gedruckt
    </div>
    <div class="alert alert-danger" ng-show="vm.printed === false"><i class="fa fa-warning"></i> Druck der Überweisung
      fehlgeschlagen
    </div>
    <div class="alert alert-danger" ng-show="vm.previewed === false"><i class="fa fa-warning"></i> Überweisungsvorschau fehlgeschlagen</div>


    <div ng-hide="vm.standalone">
      <button class="btn btn-success" ng-disabled="refform.$invalid" type="button" ng-click="vm.add();" tabindex="50">
        Speichern
      </button>


      <button class="btn btn-danger" type="button" ng-click="vm.cancel()" tabindex="51">
        Abbrechen
      </button>
    </div>
  </div>

  <div class="spacer-top"></div>
  <div class="alert alert-success" ng-show="vm.saved"><i class="fa fa-check text-success"></i> Überweisung erfolgreich gespeichert!</div>
  <div class="alert alert-info" ng-show="vm.canceled"><i class="fa fa-info-circle text-primary"></i> Erstellen der Überweisung wurde abgebrochen.</div>
  <div class="alert alert-danger" ng-show="vm.savefailed"><i class="fa fa-warning text-danger"></i> Überweisung konnte nicht gespeichert werden!</div>
</form>

<div style="min-height:3cm">&nbsp;</div>